import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    // try {
    //   const { data } = await axios.post('/api/auth/admin/login', {
    //     email,
    //     password,
    //   });
    //   console.log(data);
    //   localStorage.setItem('adminToken', data.token);
    //   navigate('/admin/dashboard');
    // } catch (err) {
    //   setError('Invalid email or password');
    // }

    try {
      setLoading(true);
      const response = await axios.post('/api/auth/admin/login', {
        email,
        password,
      });

      console.log(response);
      if (response) {
        localStorage.setItem('adminToken', response.data.token);
        toast.success('Login successful');

        // history.push('/owner-dashboard');
        navigate('/admin/dashboard');
      } else {
        setError('Invalid login credentials.');

        toast.error('Invalid login credentials.');
      }
    } catch (error) {
      setError('Login failed. Please check your credentials.');

      toast.error('Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex justify-center items-center h-screen bg-gray-200'>
      <div className='bg-white p-8 rounded shadow-lg w-full max-w-md'>
        <h1 className='text-2xl font-bold mb-6 text-center'>Admin Login</h1>
        {error && <p className='text-red-500'>{error}</p>}
        <form onSubmit={handleLogin}>
          <div className='mb-4'>
            <label
              htmlFor='email'
              className='block text-sm font-medium text-gray-700'
            >
              Email
            </label>
            <input
              type='email'
              id='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className='mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
              required
            />
          </div>
          <div className='mb-4'>
            <label
              htmlFor='password'
              className='block text-sm font-medium text-gray-700'
            >
              Password
            </label>
            <input
              type='password'
              id='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className='mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
              required
            />
          </div>
          <button
            type='submit'
            className='w-full bg-indigo-600 text-white py-2 px-4 rounded hover:bg-indigo-700 transition duration-200'
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
